
import { Component, Vue } from 'vue-property-decorator';
import OsSheet from '@/components/core/sheet/OsSheet.vue';
import OsSheetContent from '@/components/core/sheet/OsSheetContent.vue';
import OsLoadingIndicator from '@/components/core/OsLoadingIndicator.vue';
import { statisticsApi } from '@/apis';
import { ApexOptions } from 'apexcharts';
import { IKeyValuePair } from '@/models/core';

@Component({
  components: { OsLoadingIndicator, OsSheetContent, OsSheet }
})
export default class OsStatisticsCardGeneral extends Vue {
  value: IKeyValuePair<string, number>[] | null = null;
  ready = false;

  async created() {
    this.value = await statisticsApi.getDiscDistribution();

    await this.setSeries();
  }

  series: any = [];

  get options(): ApexOptions {
    return {
      chart: {
        toolbar: {
          show: false
        },
        type: 'pie'
      },
      theme: {
        monochrome: {
          enabled: true
        }
      },
      legend: {
        position: 'bottom'
      },
      plotOptions: {
        bar: {
          borderRadius: 0,
          horizontal: true
        }
      },
      dataLabels: {
        enabled: false
      },
      labels: this.value ? this.value.map((d) => d.key.toUpperCase()) : []
    };
  }

  async setSeries() {
    this.ready = false;

    if (!this.value) {
      return;
    }

    this.series = this.value.map((d) => d.value);

    this.ready = true;
  }
}
